import Container from "./Container";

const Contact = () => {
  return (
    <div className=" py-20">
      <Container>
        <h2
          className="text-3xl font-bold text-center mb-10 tracking-wider"
          id="contact"
        >
          CONTACT
        </h2>
        <div className="flex justify-center mb-4">
          <a
            href="https://www.linkedin.com/in/mizukikawabe/"
            className="mr-10 flex items-center text-xl"
          >
            <i className="devicon-linkedin-plain mr-1 h-color"></i>
            LinkedIn
          </a>
          <a
            href="https://github.com/Mizuki-Kawabe"
            className="flex items-center text-xl"
          >
            <i className="devicon-github-original mr-1 h-color"></i>
            Github
          </a>
        </div>
      </Container>
    </div>
  );
};

export default Contact;
